export class ModificaPasswordReset {
  newPassword: string;
  cNewPassword: string;
  token: string;
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/models/mod-pass-reset.ts